import { gql } from 'graphql-request'

export const AUTHENTICATE_WITH_PRIVY = gql`
  mutation AuthenticateWithPrivy($input: AuthenticateWithPrivyInput!) {
    authenticateWithPrivy(input: $input) {
      token
    }
  }
`
